import { IPaginator } from 'models/paginator';

export const exportTimeout = 600000; // 10 minutes
const exportRecordsLimitAmount = 30000;

export const isExportAvailable = (paginator: IPaginator | null) =>
  !!(paginator && paginator.totalElements >= exportRecordsLimitAmount);
